import { Box } from "@mui/material";

export const WhaleMascot = () => {
  return (
    <Box
      component="img"
      src="/whale-mascot.png"
      alt="Whale mascot"
      sx={{
        position: "absolute",
        left: { xs: 10, md: 99 },
        top: { xs: 200, md: 286 },
        width: { xs: 120, md: 242 },
        height: "auto", // ⬅️ zadrži proporcije
        maxWidth: "25vw", // ⬅️ KLJUČNO — ne dozvoli da bude preširoka
        objectFit: "contain",
        zIndex: 0,
        mixBlendMode: "normal",
        filter: "drop-shadow(0 0 1px rgba(0,0,0,0))",
        animation: "swim 3s ease-in-out infinite",

        "@media (max-width: 1024px)": {
          maxWidth: "20vw", // iPad — dodatno smanjenje
        },
        "@media (max-width: 768px)": {
          maxWidth: "30vw", // mobiteli
        },

        "@keyframes swim": {
          "0%, 100%": {
            transform: "translateY(0) rotate(0deg)",
          },
          "50%": {
            transform: "translateY(-15px) rotate(-2deg)",
          },
        },
      }}
    />
  );
};
